<template>
  <div class="copy-right">Copyright©51job.All Rights Reserved.</div>
</template>

<script>
export default {
  name: "CopyRight",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="less" scoped>
.copy-right {
  position: fixed;
  bottom: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  color: white;
  font-size: 0.2rem;
  opacity: 0.5;
}
</style>